import React from 'react';
import { useSelector } from 'react-redux';
import { SBox, SIcon } from '@avalara/skylab-sdk/react';
import { selectState } from '../../../selectors';
const integrationDetails = [
    'Connect seamlessly to AvaTax for up-to-date sales tax calculation',
    'Send tax calculations to your sales applications and pull sales order data for returns filing',
    'Free with your AvaTax subscription',
];
const IntegrationDetailsPanel = () => {
    const { account: { connector } } = useSelector(selectState);
    return (React.createElement(SBox, { className: 'secondary pad-all-md' },
        React.createElement("h1", { className: 'pad-bottom-md' }, `Add ${connector.name} to your account`),
        integrationDetails.map((step, i) => React.createElement("p", { className: 'margin-bottom-sm', key: `nextstep${i}` },
            React.createElement(SIcon, { name: 'check', className: 'margin-right-sm' }),
            React.createElement("span", { className: 'text-md' }, step)))));
};
export default IntegrationDetailsPanel;
